/**
 * Medication-related constants used throughout the application
 */

// Medication timing periods - using lowercase for consistent comparison
export const MEDICATION_TIMING = {
  MORNING: 'morning',
  AFTERNOON: 'afternoon',
  EVENING: 'evening',
  NIGHT: 'bedtime', // Changed from 'night' to 'bedtime' for consistency
  BEDTIME: 'bedtime' // Added explicit BEDTIME constant to ensure full consistency
};

// Display names for medication timing periods - for UI display
export const MEDICATION_TIMING_DISPLAY = {
  [MEDICATION_TIMING.MORNING]: 'Morning',
  [MEDICATION_TIMING.AFTERNOON]: 'Afternoon',
  [MEDICATION_TIMING.EVENING]: 'Evening',
  [MEDICATION_TIMING.NIGHT]: 'Bedtime'
};

// CSS classes for medication timing periods
export const MEDICATION_TIMING_COLORS = {
  [MEDICATION_TIMING.MORNING]: 'text-amber-500',
  [MEDICATION_TIMING.AFTERNOON]: 'text-orange-500',
  [MEDICATION_TIMING.EVENING]: 'text-blue-500',
  [MEDICATION_TIMING.NIGHT]: 'text-indigo-600'
};

// Placeholder default timing if none is specified
export const DEFAULT_MEDICATION_TIMING = MEDICATION_TIMING.MORNING;

// Food instruction options
export const FOOD_INSTRUCTION_OPTIONS = {
  BEFORE: 'before',
  WITH: 'with',
  AFTER: 'after',
  NONE: 'none'
};
